var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#0E5AA7",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.948 101.98C104.796 99.6493 104.262 97.3596 103.368 95.2019C102.205 92.4017 100.29 89.9783 97.8338 88.2003C95.9348 86.7764 93.7412 85.7953 91.4138 85.3291C87.4005 84.878 83.4732 83.8509 79.753 82.2793C79.4974 82.1023 79.251 81.9124 79.0148 81.7103C85.9988 76.612 89.9952 68.3783 89.6801 59.7371C89.6801 46.0754 80.8692 35 70.0006 35C59.1321 35 50.3212 46.0754 50.3212 59.7371C50.0061 68.3797 54.0041 76.6146 60.9903 81.7124C60.7549 81.9138 60.5094 82.103 60.2547 82.2793C56.5345 83.8508 52.6072 84.878 48.5939 85.3291C46.2665 85.7954 44.0728 86.7765 42.1736 88.2003C39.7178 89.9784 37.8024 92.4018 36.6395 95.2019C35.7456 97.3596 35.2117 99.6494 35.0591 101.98C34.9912 102.985 34.9907 103.994 35.0578 105H105.001C105.001 105 104.96 102.142 104.948 101.98Z",
    fill: "#0E5AA7",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileIcon);
export default __webpack_public_path__ + "static/media/user-profile-icon.a93dc907fc79a9a6bb063bb4bb5d69fae76578e231c34b17e4f1e64b4bb19be7.svg";
export { ForwardRef as ReactComponent };